import { CloseIcon } from "./closeIcon";
import React from "react";
function TodoItems(props){

   

    return(
        <li className="taskApp__items">
        <div className="taskApp__itemsContainer">
            <span className={`taskApp__check ${props.completed && "taskApp__check-complete"}`} onClick={props.onComplete}>
            </span>
            <p className={`taskApp__task ${props.completed && "taskApp__task-complete"}`}>{props.text}</p>
        </div>
        <div className="taskApp__deleteBtnContainer">
            <CloseIcon  className="taskApp__deleteIcon"
            onClick = {props.onDelete}
            onMouseOver = {() =>{
                console.log(props.stroke)
            }}
            />
        </div>
        </li>
    );
   
}

export {TodoItems};